import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { catchError, defer, finalize, map, of } from 'rxjs';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { FullPageMaskService, SpinnerModule } from 'common';
import { CommonModule } from '@angular/common';
import { SenderIdService } from '../../../services/sender-id-api.service';
import { ToxicityListItem } from '../../../interfaces/toxicity-list-item.interface';
import { MatIconModule } from '@angular/material/icon';

export interface ToxicityDialogData {
  senderId: number;
  senderIdText: string;
}

@Component({
  selector: 'si-toxicity-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatTableModule, CommonModule, SpinnerModule, MatIconModule],
  templateUrl: './toxicity-dialog.component.html',
  styleUrls: ['./toxicity-dialog.component.scss'],
})
export class ToxicityDialogComponent {
  public readonly columns = ['type', 'rate'];

  private readonly maskService = inject(FullPageMaskService);
  private readonly senderIdService = inject(SenderIdService);
  private readonly dialogRef = inject(MatDialogRef<ToxicityDialogComponent>);
  public data = inject<ToxicityDialogData>(MAT_DIALOG_DATA);
  public isFetching = true;

  public dataSource$ = defer(() => {
    this.maskService.showLoading();
    return this.senderIdService.getSenderIdToxicityList$(this.data.senderId);
  }).pipe(
    map((data) => {
      return new MatTableDataSource<ToxicityListItem>(data);
    }),
    finalize(() => {
      this.maskService.hideLoading();
      this.isFetching = false;
    }),
    catchError(() => {
      return of(new MatTableDataSource<ToxicityListItem>([]));
    })
  );

  handleClose() {
    this.dialogRef.close();
  }
}
